import React from "react";
import TabPanel from ".././TabPanel";
import EmployeePicker from ".././Assignment/EmployeePicker";
import {
  Dialog,
  useMediaQuery,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import Employee from "../../types/Employee";

interface IProps {
  onCancel: () => void;
  onConfirm: (selectedEmployees: Array<Employee>) => void;
  showModal: boolean;
  companyId: string;
}

export default function EmployeePickerDialog(props: IProps) {
  const [tabIndex] = React.useState(0);
  const [employeeIds, setEmployeeIds] = React.useState<string[]>([]);
  const [employees, setEmployees] = React.useState(Array<Employee>());
  const { onCancel, onConfirm, companyId } = props;
  const theme: any = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  function onEmployeeSelected(employee: Employee) {
    let id = employee.employeeId;
    let idsArray = Array.from(employeeIds);
    let employeesArray = Array.from(employees);
    let index = idsArray.indexOf(id);
    if (index === -1) {
      employeesArray.push(employee);
      idsArray.push(id);
    } else {
      employeesArray.splice(index, 1);
      idsArray.splice(index, 1);
    }

    setEmployees(employeesArray);
    setEmployeeIds(idsArray);
  }

  function onClose() {
    onCancel();
    setEmployees([])
    setEmployeeIds([])
  }

  function onSave() {
    onConfirm(employees)
    setEmployees([])
    setEmployeeIds([])
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      aria-labelledby="customized-dialog-title"
      maxWidth="sm"
      open={props.showModal}
      className="employee-create">

      <DialogTitle id="customized-dialog-title">Add Employee</DialogTitle>
      <DialogContent
        style={{ padding: 0, borderBottom: "none", display: "flex" }}
        dividers
      >
        <TabPanel value={tabIndex} index={0}>
          <div className="modal" style={{ width: 500, height: 400 }}>
            <EmployeePicker
              companyId={companyId}
              selectedIds={employeeIds}
              employeesArray={employees}
              onItemSelected={onEmployeeSelected}
            />
          </div>
          <p style={{ textAlign: 'center', color: '#9f9f9f' }}>*Inactive User Profiles will not be displayed in search results</p>
        </TabPanel>


      </DialogContent>
      <DialogActions style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          form="create-employee-form"
          variant="contained"
          color="primary"
          onClick={onSave}
        >
          Save
        </Button>
      </DialogActions>

    </Dialog >
  )
}